var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCimb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.4004V116.7H121V11.4004H7ZM82.4 101.1H21.3L48.6 63.8004L21.3 29.7004H82.4L113 63.8004L82.4 101.1Z",
    fill: "#790008"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M21.3008 101.101H82.4008L113.001 63.8008H48.7008L21.3008 101.101Z",
    fill: "#EC1C24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M21.3008 101.101H82.4008L113.001 63.8008H48.7008L21.3008 101.101Z",
    fill: "#EC1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCimb);
export default __webpack_public_path__ + "static/media/cimb - _ธนาคาร ซีไอเอ็มบี ไทย.de0ca5d5886e14dba8eeadc63dc269b0.svg";
export { ForwardRef as ReactComponent };